/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { eversignDialogRoute, isDataSourceEmpty } from '@gh/common-external-shared';
import { getRouteInitData, getRouteParam } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogService, WaitingService } from '@gh/core-ui';
import { isNotNil, openInNewWindow } from '@gh/core-util';
import { CustomerUserContext } from '@gh/customer-shared';
import { OfficeStatus } from '@gh/customer-shared-data';
import { filter$, skip$ } from '@gh/rx/operators';
import { includes } from 'lodash';
import { CustomerEDocumentBusinessService } from '../../resources/customer-e-document-business.service';
import * as i0 from "@angular/core";
import * as i1 from "../../resources/customer-e-document-business.service";
import * as i2 from "@angular/router";
import * as i3 from "@gh/core-ui";
import * as i4 from "@gh/core-mls";
import * as i5 from "@gh/customer-shared";
import * as i6 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i7 from "@angular/material/sort";
import * as i8 from "@angular/common";
import * as i9 from "../../../common-external-shared/components/ext-load-tracker/ext-load-tracker.component";
import * as i10 from "@angular/flex-layout/flex";
import * as i11 from "@angular/material/table";
import * as i12 from "@angular/flex-layout/extended";
import * as i13 from "@angular/material/button";
import * as i14 from "@angular/material/card";
import * as i15 from "../../../core-mls/translation/translate.pipe";
import * as i16 from "../../../common-external-shared/table/connect.pipe";
import * as i17 from "../../../core-type/pipes/type-format.pipe";
function CustomerEDocumentsListComponent_gh_ext_load_tracker_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "gh-ext-load-tracker", 4);
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_sent_date"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var eDocument_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, eDocument_r13.sentDate, "ShortDate"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_documents"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var eDocument_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(eDocument_r14.documents);
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 26);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_status"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var eDocument_r15 = ctx.$implicit;
    var ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ext-primary-color", !ctx_r7.isEDocumentSigned(eDocument_r15));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.statusColumnValue(eDocument_r15), " ");
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-cell", 28);
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); var eDocument_r16 = i0.ɵɵnextContext().$implicit; var ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.signEDocument(eDocument_r16); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_sign"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r24); var eDocument_r16 = i0.ɵɵnextContext().$implicit; var ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.viewEDocument(eDocument_r16); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_view"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 29);
    i0.ɵɵtemplate(1, CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_1_Template, 3, 3, "button", 30);
    i0.ɵɵtemplate(2, CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_button_2_Template, 3, 3, "button", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var eDocument_r16 = ctx.$implicit;
    var ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isEDocumentActive(eDocument_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isEDocumentSigned(eDocument_r16));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_header_row_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_row_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_22_Template(rf, ctx) { if (rf & 1) {
    var _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵlistener("click", function CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); var eDocument_r26 = i0.ɵɵnextContext().$implicit; var ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.signEDocument(eDocument_r26); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_sign"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_23_Template(rf, ctx) { if (rf & 1) {
    var _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); var eDocument_r26 = i0.ɵɵnextContext().$implicit; var ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.viewEDocument(eDocument_r26); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_view"));
} }
function CustomerEDocumentsListComponent_ng_container_5_mat_card_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 34);
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵelementStart(2, "div", 35);
    i0.ɵɵelementStart(3, "div", 36);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 37);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 35);
    i0.ɵɵelementStart(10, "div", 36);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 37);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 35);
    i0.ɵɵelementStart(16, "div", 36);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 37);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "mat-card-actions");
    i0.ɵɵtemplate(22, CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_22_Template, 3, 3, "button", 38);
    i0.ɵɵtemplate(23, CustomerEDocumentsListComponent_ng_container_5_mat_card_17_button_23_Template, 3, 3, "button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var eDocument_r26 = ctx.$implicit;
    var ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 10, "lbl_sent_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 12, eDocument_r26.sentDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 15, "lbl_documents"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(eDocument_r26.documents);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 17, "lbl_status"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ext-primary-color", !ctx_r12.isEDocumentSigned(eDocument_r26));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.statusColumnValue(eDocument_r26), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.isEDocumentActive(eDocument_r26));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isEDocumentSigned(eDocument_r26));
} }
function CustomerEDocumentsListComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-table", 5);
    i0.ɵɵelementContainerStart(2, 6);
    i0.ɵɵtemplate(3, CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_3_Template, 3, 3, "mat-header-cell", 7);
    i0.ɵɵtemplate(4, CustomerEDocumentsListComponent_ng_container_5_mat_cell_4_Template, 3, 4, "mat-cell", 8);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(5, 9);
    i0.ɵɵtemplate(6, CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_6_Template, 3, 3, "mat-header-cell", 10);
    i0.ɵɵtemplate(7, CustomerEDocumentsListComponent_ng_container_5_mat_cell_7_Template, 2, 1, "mat-cell", 11);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(8, 12);
    i0.ɵɵtemplate(9, CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_9_Template, 3, 3, "mat-header-cell", 13);
    i0.ɵɵtemplate(10, CustomerEDocumentsListComponent_ng_container_5_mat_cell_10_Template, 2, 3, "mat-cell", 14);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(11, 15);
    i0.ɵɵtemplate(12, CustomerEDocumentsListComponent_ng_container_5_mat_header_cell_12_Template, 1, 0, "mat-header-cell", 16);
    i0.ɵɵtemplate(13, CustomerEDocumentsListComponent_ng_container_5_mat_cell_13_Template, 3, 2, "mat-cell", 17);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(14, CustomerEDocumentsListComponent_ng_container_5_mat_header_row_14_Template, 1, 0, "mat-header-row", 18);
    i0.ɵɵtemplate(15, CustomerEDocumentsListComponent_ng_container_5_mat_row_15_Template, 1, 0, "mat-row", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 20);
    i0.ɵɵtemplate(17, CustomerEDocumentsListComponent_ng_container_5_mat_card_17_Template, 24, 19, "mat-card", 21);
    i0.ɵɵpipe(18, "connect");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r1.eDocumentListDataSource)("trackBy", ctx_r1.getEDocumentId);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r1.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r1.displayedColumns);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(18, 5, ctx_r1.eDocumentListDataSource));
} }
var CustomerEDocumentsListComponent = /** @class */ (function () {
    function CustomerEDocumentsListComponent(businessService, route, waitingService, translationService, dialogs, userContext) {
        this.businessService = businessService;
        this.route = route;
        this.waitingService = waitingService;
        this.translationService = translationService;
        this.dialogs = dialogs;
        this.userContext = userContext;
        this.displayedColumns = ['sentDate', 'documents', 'isSigned', 'action'];
        this.eDocumentListDataSource = new MatTableDataSource([]);
    }
    CustomerEDocumentsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var eDocumentList = getRouteInitData(this.route).eDocumentList;
        this.jobId = getRouteParam(this.route, 'jobId');
        this.initEDocumentList(eDocumentList);
        this.eDocumentListDataSource.sort = this.sort;
        this.route.paramMap.pipe(skip$(1))
            .subscribe(function (_a) {
            var params = _a.params;
            _this.jobId = params.jobId;
            _this.loadEDocuments(_this.jobId);
        });
    };
    CustomerEDocumentsListComponent.prototype.isDocumentsExist = function () {
        return !isDataSourceEmpty(this.eDocumentListDataSource);
    };
    CustomerEDocumentsListComponent.prototype.isEDocumentSigned = function (_a) {
        var isSigned = _a.isSigned;
        return isSigned;
    };
    CustomerEDocumentsListComponent.prototype.signEDocument = function (_a) {
        var _this = this;
        var embeddedSigningUrl = _a.embeddedSigningUrl;
        if (embeddedSigningUrl) {
            this.dialogs.openWithInput(eversignDialogRoute, {
                url: embeddedSigningUrl,
            }).afterClosed().pipe(filter$(isNotNil))
                .subscribe(function () { return _this.loadEDocuments(_this.jobId); });
        }
    };
    CustomerEDocumentsListComponent.prototype.viewEDocument = function (_a) {
        var viewUrl = _a.viewUrl;
        if (viewUrl) {
            openInNewWindow(viewUrl);
        }
    };
    CustomerEDocumentsListComponent.prototype.isEDocumentActive = function (_a) {
        var isSigned = _a.isSigned;
        return !isSigned
            && includes([OfficeStatus.Active, OfficeStatus.Blocked], this.userContext.currentJob.officeStatus)
            && !(this.userContext.currentJob.isFinalized || this.userContext.currentJob.isNotProceeding);
    };
    CustomerEDocumentsListComponent.prototype.statusColumnValue = function (_a) {
        var isSigned = _a.isSigned;
        return isSigned
            ? this.translationService.get('lbl_signed')
            : this.translationService.get('lbl_waiting_for_signing');
    };
    CustomerEDocumentsListComponent.prototype.getEDocumentId = function (index, eDocument) {
        return eDocument.id;
    };
    CustomerEDocumentsListComponent.prototype.loadEDocuments = function (jobId) {
        this.businessService
            .findAll(jobId).pipe(this.waitingService.operator())
            .subscribe(this.initEDocumentList.bind(this));
    };
    CustomerEDocumentsListComponent.prototype.initEDocumentList = function (eDocumentList) {
        this.eDocumentListDataSource.data = eDocumentList;
    };
    CustomerEDocumentsListComponent.ɵfac = function CustomerEDocumentsListComponent_Factory(t) { return new (t || CustomerEDocumentsListComponent)(i0.ɵɵdirectiveInject(i1.CustomerEDocumentBusinessService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.WaitingService), i0.ɵɵdirectiveInject(i4.TranslationService), i0.ɵɵdirectiveInject(i3.DialogService), i0.ɵɵdirectiveInject(i5.CustomerUserContext)); };
    CustomerEDocumentsListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomerEDocumentsListComponent, selectors: [["gh-customer-e-documents-list"]], viewQuery: function CustomerEDocumentsListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        } }, decls: 6, vars: 5, consts: [[3, "title"], ["matSort", ""], ["fxFlex", "", "noData", "", 4, "ngIf"], [4, "ngIf"], ["fxFlex", "", "noData", ""], ["fxShow", "", "fxHide.lt-md", "true", 3, "dataSource", "trackBy"], ["matColumnDef", "sentDate"], ["fxFlex", "20%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "20%", 4, "matCellDef"], ["matColumnDef", "documents"], ["fxFlex", "50%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "50%", 4, "matCellDef"], ["matColumnDef", "isSigned"], ["fxFlex", "160px", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "160px", 3, "ext-primary-color", 4, "matCellDef"], ["matColumnDef", "action"], ["fxFlex", "15%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "15%", 4, "matCellDef"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], ["fxHide", "", "fxShow.lt-md", "true"], ["class", "card-list-item", 4, "ngFor", "ngForOf"], ["fxFlex", "20%", "mat-sort-header", ""], ["fxFlex", "20%"], ["fxFlex", "50%", "mat-sort-header", ""], ["fxFlex", "50%"], ["fxFlex", "160px", "mat-sort-header", ""], ["fxFlex", "160px"], ["fxFlex", "15%", "mat-sort-header", ""], ["fxFlex", "15%"], ["mat-flat-button", "", "type", "button", "class", "small cell-button", 3, "click", 4, "ngIf"], ["mat-stroked-button", "", "type", "button", "class", "small cell-button", "color", "primary", 3, "click", 4, "ngIf"], ["mat-flat-button", "", "type", "button", 1, "small", "cell-button", 3, "click"], ["mat-stroked-button", "", "type", "button", "color", "primary", 1, "small", "cell-button", 3, "click"], [1, "card-list-item"], [1, "card-content-item", "full-width"], [1, "card-content-item-title"], [1, "card-content-item-value"], ["mat-flat-button", "", "type", "button", "color", "primary", "class", "small", 3, "click", 4, "ngIf"], ["mat-stroked-button", "", "type", "button", "class", "small", 3, "click", 4, "ngIf"], ["mat-flat-button", "", "type", "button", "color", "primary", 1, "small", 3, "click"], ["mat-stroked-button", "", "type", "button", 1, "small", 3, "click"]], template: function CustomerEDocumentsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content", 1);
            i0.ɵɵtemplate(4, CustomerEDocumentsListComponent_gh_ext_load_tracker_4_Template, 1, 0, "gh-ext-load-tracker", 2);
            i0.ɵɵtemplate(5, CustomerEDocumentsListComponent_ng_container_5_Template, 19, 7, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "lbl_docs_sent_for_signing"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.isDocumentsExist());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isDocumentsExist());
        } }, directives: [i6.ExtPageComponent, i6.ExtPageTitleDirective, i6.ExtPageContentComponent, i7.MatSort, i8.NgIf, i9.ExtLoadTrackerComponent, i10.DefaultFlexDirective, i11.MatTable, i12.DefaultShowHideDirective, i11.MatColumnDef, i11.MatHeaderCellDef, i11.MatCellDef, i11.MatHeaderRowDef, i11.MatRowDef, i8.NgForOf, i11.MatHeaderCell, i7.MatSortHeader, i11.MatCell, i13.MatButton, i11.MatHeaderRow, i11.MatRow, i14.MatCard, i14.MatCardContent, i14.MatCardActions], pipes: [i15.TranslatePipe, i16.ConnectPipe, i17.TypeFormatPipe], styles: [".mat-cell[_ngcontent-%COMP%] {\n  font-size: 18px;\n  line-height: 25px;\n  \n  margin: 5px 10px 5px 0;\n   }"] });
    return CustomerEDocumentsListComponent;
}());
export { CustomerEDocumentsListComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CustomerEDocumentsListComponent, [{
        type: Component,
        args: [{
                selector: 'gh-customer-e-documents-list',
                templateUrl: 'customer-e-documents-list.component.html',
                styleUrls: ['customer-e-documents-list.component.scss'],
            }]
    }], function () { return [{ type: i1.CustomerEDocumentBusinessService }, { type: i2.ActivatedRoute }, { type: i3.WaitingService }, { type: i4.TranslationService }, { type: i3.DialogService }, { type: i5.CustomerUserContext }]; }, { sort: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }] }); })();
